import React, { useEffect } from "react";
import { DatePicker, Space } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { setEditDateOfBirth } from "actions/userManagement";
// import { setInstallments } from "actions/course";

function StartDate_Picker({
  setInstallments,
  installments,
  index,
  value,
  setCourseStartDate,
  setInstCust,
  price,
}) {
  function onChange(date, dateString) {
    // console.log("start date", dateString);
    if (
      moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD") !== "Invalid date"
    ) {
      // console.log(
      //   "start date",
      //   moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD")
      // );
      setCourseStartDate(moment(dateString, "DD-MM-YYYY").format("YYYY-MM-DD"));
    } else {
    }

    // setInstallments([...installments]);
  }
  function disabledDate(current) {
    if (current < moment().startOf("day")) {
      return true;
    } else {
      return false;
    }
    // return !(current && current >= moment());
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={50}>
      <DatePicker
        allowClear={false}
        className="datePicker"
        onChange={onChange}
        value={
          value !== null
            ? moment(
              moment(value, "YYYY-MM-DD").format("DD-MM-YYYY"),
              "DD-MM-YYYY"
            )
            : ""
        }
        placeholder={["Select a date"]}
        style={{ width: "100%" }}
        format={"DD-MM-YYYY"}
        // disabledDate={disabledDate}
        disabledDate={() => false}
      />
    </Space>
  );
}

// export default Date_Picker1
const mapStateToProps = (state) => {
  const { } = state.course;
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  setEditDateOfBirth: (date) => dispatch(setEditDateOfBirth(date)),
  // setInstallments: (val) => dispatch(setInstallments(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StartDate_Picker);
